const CommercialOfferBox = ({
  label,
  feePercent,
  feeFixedCents,
  trialDays,
  setupFeeCents,
  softwareSubscriptionFeeCents,
  notes,
  showHeader = true,
  style,
}) => {
  const hasEconomicTerms = [feePercent, feeFixedCents, trialDays, setupFeeCents, softwareSubscriptionFeeCents]
    .some((value) => value != null);

  if (!label && !hasEconomicTerms) return null;

  return (
    <div style={{
      padding: '10px 14px',
      background: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '10px',
      display: 'grid',
      gap: '6px',
      ...style
    }}>
      {showHeader && (
        <div style={{ fontSize: '12px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Offerta commerciale</div>
      )}
      {label && (
        <div>
          <span style={{ background: '#f0fdf4', color: '#166534', padding: '2px 10px', borderRadius: '6px', fontWeight: 600, fontSize: '13px' }}>{label}</span>
        </div>
      )}
      {hasEconomicTerms && (
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '13px', color: '#334155' }}>
          {feePercent != null && (
            <span>Fee: <strong>{feePercent}%</strong></span>
          )}
          {feeFixedCents != null && (
            <span>Fee fissa: <strong>€{(feeFixedCents / 100).toFixed(2)}</strong></span>
          )}
          {trialDays != null && (
            <span>Trial: <strong>{trialDays} giorni</strong></span>
          )}
          {setupFeeCents != null && (
            <span>Setup: <strong>€{(setupFeeCents / 100).toFixed(2)}</strong></span>
          )}
          {softwareSubscriptionFeeCents != null && (
            <span>Abbonamento: <strong>€{(softwareSubscriptionFeeCents / 100).toFixed(2)}</strong> / mese</span>
          )}
        </div>
      )}
      {notes && (
        <div style={{ fontSize: '13px', color: '#475569', borderTop: '1px solid #e2e8f0', paddingTop: '6px', marginTop: '2px' }}>
          <strong>Condizioni particolari:</strong> {notes}
        </div>
      )}
    </div>
  );
};

export default CommercialOfferBox;
